// extracted by mini-css-extract-plugin
export default {"heading":"LoginForm_heading__p1NhX","helpingMessage":"LoginForm_helpingMessage__YEybB"};